import React, { type ReactNode } from 'react';
import { TextField, type TextFieldProps } from '@mui/material';

export type InputProps = Omit<
  TextFieldProps,
  'label' | 'value' | 'onChange'
> & {
  label?: string;
  value: string;
  setValue: (value: string) => void;
  hideLabel?: boolean;
  info?: ReactNode;
};

export default function Input({
  label,
  value,
  setValue,
  hideLabel = false,
  info,
  ...rest
}: InputProps) {
  const field = (
    <TextField
      label={hideLabel ? undefined : label}
      placeholder={hideLabel ? label : undefined}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onWheel={(e) => (e.target as HTMLElement).blur()}
      variant="outlined"
      fullWidth
      {...rest}
    />
  );

  if (!info) return field;

  return (
    <div
      style={{ display: 'flex', alignItems: 'center', gap: 4, width: '100%' }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>{field}</div>
      {info}
    </div>
  );
}
